import React, { useCallback, useEffect, useMemo } from "react";
import { useQuery } from "@apollo/react-hooks";
import { get, isEmpty } from "lodash";
import { useAuth0 } from "@dhn/components/contexts/react-auth0-spa";
import PrivateRoute from "@dhn/components/hocs/private-route";
import { GET_PROFILE, GET_VALIDATION_EXPIRE, OPTIONS } from "../queries";
import usePermissionsNavigation from "./usePermissionsNavigation";
import PharmacyRoutes from "../routes/pharmacyRoutes";
import CallCenterRoutes from "../routes/callCenterRoutes";
import DoctorOfficeRoutes from "../routes/doctorOfficeRoutes";
import history from "@dhn/shared/history";

const DefaultLayout = React.lazy(() => import("../containers/DefaultLayout"));

export default function useAppRouteData({ loading, user }) {
  const { data, loading: ploading } = useQuery(GET_PROFILE, {
    skip: loading || !user,
    fetchPolicy: "network-only",
    variables: {
      where: { usersub: get(user, "sub") },
    },
  });

  const { data: oData, loading: oLoading } = useQuery(OPTIONS, {
    skip: loading || !user,
    variables: {},
  });

  console.log("data", data);

  const { data: { getValidationCardsToExpire } = {} } = useQuery(
    GET_VALIDATION_EXPIRE,
    {
      skip: isEmpty(data),
      fetchPolicy: "network-only",
      variables: {
        where: { userId: data?.user?.id },
      },
    },
  );
  console.log("este es el primero", getValidationCardsToExpire);

  const ctx = useAuth0();
  const { permissionViews, navigation } = usePermissionsNavigation(
    data?.profile,
  );

  const redirectLoggin = useCallback(() => {
    ctx.logout({ returnTo: window.location.origin });
  }, [ctx]);

  const doctorProfile = useMemo(() => {
    if (data?.profile?.layoutsId !== 3) return null;
    try {
      const storedProfile = JSON.parse(sessionStorage.getItem("doctorProfile"));
      if (!storedProfile) return null;

      const currentProfile = data?.profile?.doctorProfiles?.find(
        (item) =>
          String(item?.centerId) === String(storedProfile?.centerId) &&
          String(item?.branchOfficeId) === String(storedProfile?.branchOfficeId) &&
          String(item?.profileId) === String(storedProfile?.profileId),
      );
      const mergedProfile = currentProfile
        ? { ...storedProfile, ...currentProfile }
        : storedProfile;

      if (currentProfile && storedProfile?.isAdmin !== currentProfile?.isAdmin) {
        sessionStorage.setItem("doctorProfile", JSON.stringify(mergedProfile));
      }

      return mergedProfile;
    } catch (error) {
      return null;
    }
  }, [data?.profile?.doctorProfiles, data?.profile?.layoutsId]);

  useEffect(() => {
    if (
      data?.profile?.layoutsId === 3 &&
      isEmpty(data?.profile?.doctorProfiles)
    ) {
      redirectLoggin();
    }
  }, [data?.profile?.layoutsId, data?.profile?.doctorProfiles, redirectLoggin]);

  const routes = useMemo(() => {
    if (data?.profile?.layoutsId === 1) {
      return (
        <PharmacyRoutes
          profile={data?.profile}
          user={data?.user}
          pharmacy={data?.pharmacy?.fileLogo}
        />
      );
    }

    if (data?.profile?.layoutsId === 2) {
      return (
        <CallCenterRoutes
          profile={data?.profile}
          user={data?.user}
          pharmacy={data?.pharmacy?.fileLogo}
        />
      );
    }

    if (data?.profile?.layoutsId === 3) {
      if (isEmpty(data?.profile?.doctorProfiles)) {
        return null;
      }

      return (
        <DoctorOfficeRoutes
          profile={data?.profile}
          user={data?.user}
          doctorProfile={doctorProfile}
          history={history}
          ValidationData={getValidationCardsToExpire}
        />
      );
    }

    return <PrivateRoute path="/" component={DefaultLayout} />;
  }, [
    data?.profile,
    data?.user,
    data?.pharmacy,
    doctorProfile,
    getValidationCardsToExpire,
  ]);

  const appLoading = loading || ploading || oLoading;
  const canRender = !loading && !ploading;

  const providerValue = useMemo(
    () => ({
      profile: get(data, "profile"),
      parameters: get(oData, "items", []),
      permissionViews,
      navigation,
      user: get(data, "user"),
    }),
    [data, oData, permissionViews, navigation],
  );

  console.log("providerValue", providerValue);
  

  return {
    appLoading,
    canRender,
    providerValue,
    routes,
  };
}
